import tw from 'twin.macro';

const Circle = ({ handelCLick, isActive }) => {
  return (
    <div
      tw="rounded-[6px] w-[20px] h-[5px] cursor-pointer"
      css={isActive ? tw`bg-Primary_700` : tw`bg-[#fff]`}
      onClick={handelCLick}
    />
  );
};

export default Circle;
